import { render, staticRenderFns } from "./LeadCreateChildDialog.vue?vue&type=template&id=1a6704ca"
import script from "./LeadCreateChildDialog.vue?vue&type=script&lang=ts"
export * from "./LeadCreateChildDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports